type Truthy = <T>(
  value?: T
) => value is Exclude<T, false | null | undefined | '' | 0>;

export default Boolean as unknown as Truthy;
